import styled from 'styled-components';
import { palette } from 'styled-theme';

export const ContentBox = styled.div`
  background: transparent;
  border-radius: 12px;
  padding: 2rem;
  min-width: 100%;
  overflow: auto;
  border: 1px solid ${palette('border', 1)};
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid ${(props) => (props.checked ? '#3DB654' : '#6366f1')};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => (props.checked ? '#f0f9f4' : 'transparent')};

  &:hover {
    border-color: #3db654;
    background: #f0f9f4;
  }

  input[type='radio'] {
    margin-right: 12px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    font-weight: ${(props) => (props.checked ? '600' : '400')};
    color: ${(props) => (props.checked ? '#2c3e50' : '#4a5568')};
  }
`;

export const FileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
